import React, { useState } from 'react';
import { gql, useQuery } from '@apollo/client';
import { FormRenderer } from './lib/formRender';
import { useParams } from 'react-router-dom';

const GET_PARTICIPANT_DOCUMENT = gql`
  query GetParticipantDocument($documentID: Int!) {
    getParticipantDocument(documentID: $documentID) {
      id
      odrparticipant
      contents
      template
      published
      tags
      cin
      name
      type
      metadata
    }
  }
`;

export const ParticipantDocument = () => {
  const { documentID } = useParams() as { documentID?: string };
  const [document, setDocument] = useState<any>(null);
  const [contents, setContents] = useState<any>({});
  const [template, setTemplate] = useState<any[]>([]);

  const parsedDocumentId = parseInt(documentID || '0', 10);

  const { loading, error } = useQuery(GET_PARTICIPANT_DOCUMENT, {
    variables: { documentID: parsedDocumentId },
    skip: !documentID || Number.isNaN(parsedDocumentId),
    onCompleted: (data) => {
      const nextDocument = data?.getParticipantDocument;
      if (!nextDocument) {
        return;
      }

      setDocument(nextDocument);
      setContents(JSON.parse(nextDocument.contents || '{}'));
      setTemplate(JSON.parse(nextDocument.template || '[]'));
    },
  });

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error || !document) {
    return <p>Error :(</p>;
  }

  return (
    <div>
      <FormRenderer
        readOnly={true}
        formTemplate={template}
        formState={contents}
        setFormState={setContents}
        onSubmit={() => {}}
      />
    </div>
  );
};

export default ParticipantDocument;
